export interface Review {
  id: string;
  name: string;
  location: string;
  date: string;
  rating: number;
  text_de: string;
  text_en: string;
  tour_name_de: string;
  tour_name_en: string;
}

export const reviews: Review[] = [
  {
    id: 'rev-1',
    name: 'Familie Müller',
    location: 'Berlin, Deutschland',
    date: 'März 2026',
    rating: 5,
    text_de: 'Unser privater Luxor-Tagesausflug mit Yallabina Tours war fantastisch! Unser Ägyptologe Ahmed sprach perfektes Deutsch und hat uns die Geschichte so lebendig erklärt. Wir waren mit zwei Kindern unterwegs und alles war perfekt organisiert.',
    text_en: 'Our private Luxor day trip with Yallabina Tours was fantastic! Our Egyptologist Ahmed spoke perfect German and explained the history so vividly. We traveled with two children and everything was perfectly organized.',
    tour_name_de: 'Luxor Tagesausflug',
    tour_name_en: 'Luxor Day Tour',
  },
  {
    id: 'rev-2',
    name: 'Thomas & Sabine W.',
    location: 'München, Deutschland',
    date: 'Februar 2026',
    rating: 5,
    text_de: 'Zum dritten Mal mit Yallabina unterwegs — und wieder alles top! Diesmal Kairo mit Flug gebucht. Der Service ist erstklassig, die Guides sind hochprofessionell. Keine versteckten Kosten, alles transparent.',
    text_en: 'Traveling with Yallabina for the third time — and everything was great again! This time booked Cairo by flight. The service is first-class, the guides are highly professional. No hidden costs, everything transparent.',
    tour_name_de: 'Kairo mit Flug',
    tour_name_en: 'Cairo by Flight',
  },
  {
    id: 'rev-3',
    name: 'Markus K.',
    location: 'Wien, Österreich',
    date: 'Januar 2026',
    rating: 5,
    text_de: 'Wir haben den privaten Bootsausflug gebucht und es war der beste Tag unseres Urlaubs! Das Boot war luxuriös, die Schnorchelspots atemberaubend und das Mittagessen an Bord köstlich. Absolut empfehlenswert!',
    text_en: 'We booked the private boat trip and it was the best day of our vacation! The boat was luxurious, the snorkeling spots breathtaking, and the lunch on board delicious. Absolutely recommended!',
    tour_name_de: 'Privater Bootsausflug',
    tour_name_en: 'Private Boat Trip',
  },
  {
    id: 'rev-4',
    name: 'Familie Schmidt',
    location: 'Hamburg, Deutschland',
    date: 'Dezember 2025',
    rating: 5,
    text_de: 'Die Quad-Safari war ein Highlight für die ganze Familie! Die Kinder waren begeistert vom Kamelritt und das Beduinenessen am Abend war ein echtes Erlebnis. Alles perfekt organisiert, sehr sicher.',
    text_en: 'The quad safari was a highlight for the whole family! The kids loved the camel ride and the Bedouin dinner in the evening was a real experience. Everything perfectly organized, very safe.',
    tour_name_de: 'Quad Safari',
    tour_name_en: 'Quad Safari',
  },
  {
    id: 'rev-5',
    name: 'Anna & Peter L.',
    location: 'Zürich, Schweiz',
    date: 'November 2025',
    rating: 5,
    text_de: 'Wir waren schon mehrmals in Ägypten, aber diese Reise war dank Yallabina die schönste. Der Dendera-Tempel ist ein absolutes Muss! Unser Guide wusste unendlich viel und hat jede Frage beantwortet.',
    text_en: 'We have been to Egypt several times, but this trip was the most beautiful thanks to Yallabina. The Dendera Temple is an absolute must! Our guide knew so much and answered every question.',
    tour_name_de: 'Dendera Tempel',
    tour_name_en: 'Dendera Temple',
  },
  {
    id: 'rev-6',
    name: 'Sabrina H.',
    location: 'Frankfurt, Deutschland',
    date: 'Oktober 2025',
    rating: 4,
    text_de: 'Orange Bay ist ein Traum! Das Wasser war so klar und türkis, der Strand traumhaft weiß. Einziger kleiner Kritikpunkt: Es könnte etwas mehr Zeit auf der Insel sein. Aber ansonsten top!',
    text_en: 'Orange Bay is a dream! The water was so clear and turquoise, the beach wonderfully white. Only small criticism: there could be a bit more time on the island. But otherwise great!',
    tour_name_de: 'Orange Bay',
    tour_name_en: 'Orange Bay',
  },
  {
    id: 'rev-7',
    name: 'Familie Weber',
    location: 'Köln, Deutschland',
    date: 'September 2025',
    rating: 5,
    text_de: 'Wir haben den Flughafentransfer und mehrere Ausflüge gebucht. Alles hat reibungslos geklappt. Der Fahrer war immer pünktlich, die Fahrzeuge sauber und klimatisiert. Fühlt sich an wie ein VIP-Service!',
    text_en: 'We booked the airport transfer and several excursions. Everything went smoothly. The driver was always punctual, the vehicles clean and air-conditioned. Feels like VIP service!',
    tour_name_de: 'Transfer & Ausflüge',
    tour_name_en: 'Transfer & Excursions',
  },
  {
    id: 'rev-8',
    name: 'Michael R.',
    location: 'Stuttgart, Deutschland',
    date: 'August 2025',
    rating: 5,
    text_de: 'Abu Dabbab mit den Schildkröten war unbeschreiblich. Wir haben eine riesige Meeresschildkröte und sogar einen Dugong gesehen! Der Guide wusste genau, wo die Tiere sind. Ein magischer Moment.',
    text_en: 'Abu Dabbab with the turtles was indescribable. We saw a huge sea turtle and even a dugong! The guide knew exactly where the animals were. A magical moment.',
    tour_name_de: 'Abu Dabbab',
    tour_name_en: 'Abu Dabbab',
  },
  {
    id: 'rev-9',
    name: 'Lisa & Martin G.',
    location: 'Dresden, Deutschland',
    date: 'Juli 2025',
    rating: 4,
    text_de: 'Der 2-Tages Luxor-Trip war perfekt. Die Hotelübernachtung am Nil war wunderschön und der Besuch des Luxor-Tempels bei Nacht ist unbeschreiblich. Etwas anstrengend, aber jeden Cent wert.',
    text_en: 'The 2-day Luxor trip was perfect. The hotel overnight on the Nile was beautiful and visiting Luxor Temple at night is indescribable. A bit tiring, but worth every cent.',
    tour_name_de: 'Luxor 2 Tage',
    tour_name_en: 'Luxor 2 Days',
  },
  {
    id: 'rev-10',
    name: 'Robert S.',
    location: 'Leipzig, Deutschland',
    date: 'Juni 2025',
    rating: 5,
    text_de: 'El Gouna Stadtrundfahrt war sehr entspannend und informativ. Die Lagunen-Bootsfahrt zum Sonnenuntergang war romantisch. Perfekt für einen entspannten Nachmittag abseits der Hotelanlage.',
    text_en: 'El Gouna city tour was very relaxing and informative. The lagoon boat ride at sunset was romantic. Perfect for a relaxed afternoon away from the hotel resort.',
    tour_name_de: 'El Gouna Stadtrundfahrt',
    tour_name_en: 'El Gouna City Tour',
  },
];